import { render } from "./IconGive.vue?vue&type=template&id=b1604770"
import script from "./IconGive.vue?vue&type=script&lang=js"
export * from "./IconGive.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__